import api from '../services/axiosInstance';


export const registerUser = async (userData) => {
  

  const response = await api.post('/users/register', userData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });


  return response.data.user;
};



// login with Google
export const loginWithGoogle = async (googleData) => {
  const response = await api.post('/users/google-login', googleData); // no need for multipart
  return response.data.user;
};



// Login
export const loginUser = async ({ email, password }) => {
  const response = await api.post('/users/login', { email, password });
  return response.data.user;
};


//Logout
export const logoutUser = async () => {
  const response = await api.get('/users/logout');
  return response.data;
};

// Load profile (to restore session)


export const loadUser = async () => {
  try {
 
    const response = await api.get('/users/profile');
  
    return response.data.user;
  } catch (err) {
    if (err.response?.status === 401) {
 
      // Throwing a non-error 
      throw new Error('NotLoggedIn');
    }
    throw err;
  }
};

// Forgot Password
export const forgotPassword = async (email) => {
  const response = await api.post('/users/forgot-password', { email });
  return { message: response.data.message || response.data };
};


export const resetPassword = async ({ token, passwords }) => {
  try {
    const response = await api.put(`/users/reset/${token}`, passwords);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Reset failed';
   
    throw new Error(message);
  }
};

// Update Profile
export const updateProfile = async (userData) => {
  const response = await api.patch('/users/update-profile', userData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.user;
};

// Update Password
export const updatePassword = async (passwords) => {
  const response = await api.patch('/users/update-password', passwords);
  return response.data;
};

// Request Email Change
export const requestEmailChange = async (email) => {
  const response = await api.patch('/users/request-email-change', { email });
  return response.data;
};

// Confirm Email Change
export const confirmEmailChange = async (token) => {
  const response = await api.patch(`/users/confirm-email/${token}`);
  return response.data;
};

